import Img from "@/assets/404.svg";

export default function NotFound() {
  return (
    <div className="flex min-h-[calc(100vh-100px)] items-center justify-center p-4">
      <div className="grid max-w-md justify-center gap-2 text-center">
        <img src={Img} alt="Page not found" width={400} height={400} className="mx-auto" />
        <h2 className="m-0 text-lg">Page not found</h2>
        <p className="text-sm text-muted-foreground">
          Sorry, we could not find the requested resource.
        </p>
        <div className="mt-2 flex justify-center">
          <a
            className="flex w-fit items-center rounded-lg border border-primary-600 p-2 text-sm text-primary-600 transition-colors hover:bg-primary-600 hover:text-white"
            href="/"
          >
            Return Home
          </a>
        </div>
      </div>
    </div>
  );
}
